export interface ApplianceSelectionItem {
  name: string;
  description?: string;
}

export interface ApplianceOption {
  value: string;
  label: string;
  description?: string;
}

/**
 * Parses `appliancesSelectionItems` widget parameter from Contentful. Each item
 * can be either an object with name and an optional description, or a plain
 * string (legacy format), in which case the string is used as the name.
 *
 * Options are sorted alphabetically by name, because the key order of a JSON
 * object from Contentful isn't guaranteed.
 */
export const parseApplianceOptions = (
  items: Record<string, ApplianceSelectionItem | string> | undefined,
  locale: string
): ApplianceOption[] =>
  Object.entries(items ?? {})
    .map(([value, item]) =>
      typeof item === 'string'
        ? { value, label: item }
        : { value, label: item.name, description: item.description }
    )
    .sort((a, b) => a.label.localeCompare(b.label, locale));
